import Route from '@ember/routing/route';
import { service } from '@ember/service';
import JournalService from 'donor-elf-web/services/journal-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import { type JournalSegmentsRouteModel } from '../segments';

export interface JournalSegmentsIndexRouteModel
  extends JournalSegmentsRouteModel {
  segments: string[];
}

export default class JournalSegmentsIndexRoute extends Route {
  @service declare journalService: JournalService;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Journal Segments';
  }

  async model() {
    let parentModel = this.modelFor(
      'funds.fund.journals.journal.segments',
    ) as JournalSegmentsRouteModel;
    let segments = this.journalService.getDistinctJournalSegments(
      parentModel.journalContactInfos,
    );
    return {
      ...parentModel,
      segments,
    };
  }
}
